import React from 'react';

const YesNotQuestionIcon = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="8" fill="#AE83E2" />
            <g clipPath="url(#clip0_6086_36794)">
                <path d="M12.5 15.2632L14.8684 17.6316L20 12.5" stroke="#F8F5FD" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M28.125 11.875L11.875 28.125" stroke="#F8F5FD" strokeWidth="2" />
                <path d="M27.6236 22.3205L25.2057 24.7384L22.8855 22.4182L22.1947 23.109L24.5149 25.4292L22.2859 27.5894L22.9589 28.2626L25.1778 26.0921L27.498 28.4123L28.1888 27.7215L25.8687 25.4013L28.2865 22.9834L27.6236 22.3205Z" fill="#F8F5FD" />
            </g>
            <defs>
                <clipPath id="clip0_6086_36794">
                    <rect width="20" height="20" fill="white" transform="translate(10 10)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default YesNotQuestionIcon;